import { render } from "./ResultNews.vue?vue&type=template&id=92afadf0&ts=true"
import script from "./ResultNews.vue?vue&type=script&lang=ts"
export * from "./ResultNews.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__